export class TabVisibilityTracker {
	private startTime: number;
	private totalHiddenMs = 0;
	private lastHiddenAt: number | null;
	private firstHiddenOffsetMs: number | null;

	constructor(doc: Document | null) {
		this.startTime = performance.now();
		const isHidden = doc?.visibilityState === 'hidden';
		this.lastHiddenAt = isHidden ? this.startTime : null;
		this.firstHiddenOffsetMs = isHidden ? 0 : null;
	}

	onVisibilityChange(isHidden: boolean): void {
		const now = performance.now();
		if (isHidden) {
			if (this.lastHiddenAt === null) {
				this.lastHiddenAt = now;
			}
			if (this.firstHiddenOffsetMs === null) {
				this.firstHiddenOffsetMs = now - this.startTime;
			}
		} else if (this.lastHiddenAt !== null) {
			this.totalHiddenMs += now - this.lastHiddenAt;
			this.lastHiddenAt = null;
		}
	}

	getAttributes(doc: Document | null): {
		isActiveTab: boolean;
		tabHiddenProportion: number;
		tabFirstHiddenOffsetMs: number | null;
	} {
		const now = performance.now();
		const elapsed = now - this.startTime;

		let totalHiddenMs = this.totalHiddenMs;
		if (this.lastHiddenAt !== null) {
			totalHiddenMs += now - this.lastHiddenAt;
		}

		const tabHiddenProportion = elapsed > 0 ? totalHiddenMs / elapsed : 0;

		return {
			isActiveTab: doc ? doc.visibilityState === 'visible' : true,
			tabHiddenProportion,
			tabFirstHiddenOffsetMs: this.firstHiddenOffsetMs,
		};
	}
}
